import { Component, EventEmitter, Input, OnDestroy, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'custom-input-accesor',
  templateUrl: './custom-input-accesor.component.html',
  styleUrls: ['./custom-input-accesor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomInputAccesorComponent),
      multi: true
    }
  ]
})
export class CustomInputAccesorComponent implements  ControlValueAccessor, OnDestroy {

  @Input() isRequired: boolean = false;
  @Input() placeholder!: string;
  @Input() autocomplete: string = '';
  @Input() type: string = 'text';
  value = new FormControl(['', [], []]);
  subscriptions: Subscription[] = [];
  @Input() form?: FormGroup;
  @Input() inputName?: string;
  @Input() eye: boolean = false;
  @Input() verified: boolean = false;
  @Input() wrong: boolean = false;
  @Output() changeType = new EventEmitter<void>();
  isDisabled: boolean = false;

  writeValue(input: any): void {
    this.value.setValue(input);
  }
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.value.disable({ emitEvent: false });
    } else {
      this.value.enable({ emitEvent: false });
    }
  }

  isValidField(){
    return utils.isValidFieldForm(this.form!, this.inputName!)
  }
  errorField(){
    return utils.getFieldErrorForm(this.form!, this.inputName!)
  }
}

